import React from 'react';
import NewPageHeader from '../utils/NewPageHeader';
import WhatYouCanDo from '../utils/WhatYouCanDo';
import WhyItMatters from '../utils/WhyItMatters';
import ChangeDemandsCTA from '../utils/ChangeDemandsCTA';

export default function MakeVoiceHear() {
  return (
    <div className="body_bg">
      <NewPageHeader
        title="Make Your"
        highlightedText="Voice Heard"
        subtitle="Contact your elected representatives and demand prescription drug price transparency. Your voice matters."
        backgroundImage="/images/newpage.jpg"
        flagImage="/images/flag.jpg"
        showFlagImage={true}
      />
      <WhatYouCanDo />
      <WhyItMatters />
      <ChangeDemandsCTA />
    </div>
  );
}
